import { useEffect } from "react";

// Hides the private CEO/admin area from search engines. Overrides the global
// <meta name="robots"> (index, follow) from index.html while the admin page is
// mounted, and restores it on unmount so public pages remain indexable.
export function useAdminNoindex() {
  useEffect(() => {
    const el = document.head.querySelector('meta[name="robots"]');
    const prev = el ? el.getAttribute("content") : null;
    const prevTitle = document.title;

    let created = false;
    let meta = el;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
      created = true;
    }
    meta.setAttribute("content", "noindex, nofollow");
    meta.setAttribute("data-admin-noindex", "true");
    document.title = "Secure Sign In";

    return () => {
      meta.removeAttribute("data-admin-noindex");
      if (created) {
        meta.remove();
      } else if (prev != null) {
        meta.setAttribute("content", prev);
      }
      document.title = prevTitle;
    };
  }, []);
}

export default useAdminNoindex;
